<template>
  <div :class="[`${$options.name}--${type}`, type === 'simple' ? 'tw:px-4 tw:sm:px-6' : '']">
    <div
      :class="{
        'tw:py-3 tw:sm:py-6': type === 'simple',
        'tw:px-0': type === 'simple',
        'tw:py-4': type === 'drawer',
        'tw:px-6': type === 'drawer',
      }"
      class="EdroneNavigationTop__header-wrapper tw:flex tw:flex-wrap tw:justify-between tw:gap-2"
      style="flex: 0 1 auto"
    >
      <div :class="{ 'tw:w-full': fullWidth }" class="tw:flex tw:items-center tw:gap-2">
        <EdroneButtonIcon
          v-if="showBackIcon"
          :type="backIconBorder ? 'border' : 'plain'"
          :unique-id="uniqueId + '-navigation-top-back-icon'"
          @click="$emit('close')"
        >
          <font-awesome-icon icon="fa-light fa-arrow-left" />
        </EdroneButtonIcon>
        <!-- @slot Here goes EdroneHeader component. For `type="drawer"` use `<EdroneHeader type="h2">` -->
        <slot name="header"></slot>
      </div>

      <div :class="`${$options.name}__buttons tw:flex tw:items-center tw:gap-2`">
        <!-- @slot Here goes buttons (these on the right side) -->
        <slot name="buttons" />
        <EdroneButtonIcon
          v-if="showCloseIcon"
          :class="`${$options.name}__close-icon`"
          :disabled="false"
          :unique-id="uniqueId + '-navigation-top-close-icon'"
          type="plain"
          @click="$emit('close')"
        >
          <font-awesome-icon icon="fa-light fa-xmark" />
        </EdroneButtonIcon>
      </div>
    </div>

    <div
      v-if="$slots.notifications && type === 'simple'"
      :class="`${$options.name}__notifications tw:flex flex-column tw:pb-6 tw:gap-2`"
    >
      <!-- @slot Here goes notifications. Only for `type="simple"` -->
      <slot name="notifications" />
    </div>

    <div
      v-if="$slots.tabs"
      :class="{
        EdroneTopHeader__tabs: true,
        'tw:px-0': type === 'simple',
        'tw:px-4': type === 'drawer',
      }"
    >
      <!-- @slot Here goes EdroneTabGroup component with EdroneTabs -->
      <slot name="tabs" />
    </div>

    <hr v-if="showBottomBorder" class="edrone-hr" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";

export default defineComponent({
  name: "EdroneNavigationTop",
  components: {
    EdroneButtonIcon,
  },
  props: {
    type: {
      type: String as PropType<"simple" | "drawer">,
      default: "simple",
    },
    /**
     * Use only with the `type="drawer"`.
     * If `true`, the close icon will be shown on the right side.
     */
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * Use **only** with the `type="drawer"`.
     * If `true`, the back icon will be shown on the left side.
     */
    showBackIcon: {
      type: Boolean,
      default: false,
    },
    backIconBorder: {
      type: Boolean,
      default: false,
    },
    uniqueId: {
      type: String,
      required: false,
    },
    /**
     * Whether elements inside should take full width.
     */
    fullWidth: {
      type: Boolean,
      default: false,
    },
    showBottomBorder: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    /**
     * Emitted when the close icon is clicked.
     */
    close: null,
  },
});
</script>

<style scoped>
@reference "vue-app/assets/scss/main.css";

.EdroneNavigationTop__close-icon {
  font-size: 20px;
  @apply tw:text-default-600;
}
</style>
